import { useState } from 'react'
import styles from './QA.module.scss'

interface Props {
  contents: {
    num: number
    question: string
    answer: string
  }[]
}

const QA: React.FC<Props> = ({ contents }) => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([])

  const toggleAnswer = (index: number) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index))
    } else {
      setOpenIndexes([...openIndexes, index])
    }
  }

  const listItems = contents.map((item, i) => (
    <li key={i} className={styles.item}>
      <div
        className={styles.question_wrapper}
        onClick={() => toggleAnswer(item.num)}
        onKeyDown={() => toggleAnswer(item.num)}
        role="button"
        tabIndex={0}
      >
        <div className={styles.question}>
          <div className={styles.color_text}>Q.</div>
          <div className={styles.question_text}>{item.question}</div>
        </div>
        <button className={styles.arrow}>
          {openIndexes.includes(item.num) ? (
            <img src="/images/LP/LP202407/Icon/BsChevronUp.svg" alt="" />
          ) : (
            <img src="/images/LP/LP202407/Icon/BsChevronUp.svg" alt="" className={styles.down} />
          )}
        </button>
      </div>
      {openIndexes.includes(item.num) && (
        <div className={styles.answer}>
          <div className={styles.color_text}>A.</div>
          <div className={styles.answer_text}>{item.answer}</div>
        </div>
      )}
    </li>
  ))
  return (
    <div className={styles.qa_section}>
      <div className={styles.wrapper}>
        <div className={styles.qa_section_title}>よくあるご質問</div>
        <ul className={styles.qa_section_list}>{listItems}</ul>
      </div>
    </div>
  )
}
export default QA
